var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    style: {
      fill: "rgb(233,244,246)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.929968,0,0,0.929968,0.420192,0.420192)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4.242,
    style: {
      fill: "rgb(56,183,171)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.419674,0.112451,-0.112451,0.419674,4.15666,2.80725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.208,7.83L7.875,6L11.208,4.17C11.484,4.018 11.582,3.669 11.424,3.395L10.968,2.605C10.81,2.331 10.459,2.241 10.189,2.405L6.938,4.376L7.019,0.575C7.026,0.259 6.772,0 6.457,0L5.543,0C5.228,0 4.974,0.259 4.981,0.575L5.063,4.376L1.811,2.405C1.541,2.241 1.19,2.331 1.032,2.605L0.576,3.395C0.418,3.669 0.516,4.018 0.792,4.17L4.125,6L0.792,7.83C0.516,7.982 0.418,8.331 0.576,8.605L1.032,9.395C1.19,9.669 1.541,9.759 1.811,9.595L5.063,7.624L4.981,11.425C4.974,11.741 5.228,12 5.543,12L6.457,12C6.772,12 7.026,11.741 7.019,11.425L6.938,7.624L10.189,9.595C10.459,9.759 10.81,9.669 10.968,9.395L11.424,8.605C11.582,8.331 11.484,7.982 11.208,7.83Z",
    style: {
      fill: "rgb(229,244,247)",
      fillRule: "nonzero"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgStar);
export default __webpack_public_path__ + "static/media/bg-star.937653d632c011579cb66c52ccd06dbb.svg";
export { ForwardRef as ReactComponent };